import { FirmTier } from '../enums/firm-tier.enum';
import { FirmResponseDto } from '../models/firm.dto';
import { isIndividualContext } from '../workspace.util';

/** Display state for the always-visible active-workspace indicator (sidebar). */
export interface WorkspaceIndicator {
  name: string;
  tierLabel: string;
  isPersonal: boolean;
}

// Friendly labels — keep in sync with workspaces.component.ts cards.
const TIER_LABELS: Record<FirmTier, string> = {
  [FirmTier.Individual]: 'Individual',
  [FirmTier.Team]: 'Team',
  [FirmTier.Organization]: 'Organization',
};

/**
 * Derive the active-workspace indicator from the active firm.
 *
 * Individual context (no firm yet, or an Individual-tier firm) always presents
 * as "Personal Workspace" — the Individual firm's raw name is the user's own
 * name and is not shown. Org/Team contexts show the firm name and tier.
 *
 * @param firm Active firm from FirmContextService, or null before bootstrap.
 * @returns Indicator with display name, tier label and personal/org flag.
 */
export function deriveWorkspaceIndicator(firm: FirmResponseDto | null): WorkspaceIndicator {
  if (isIndividualContext(firm)) {
    return { name: 'Personal Workspace', tierLabel: TIER_LABELS[FirmTier.Individual], isPersonal: true };
  }
  return { name: firm!.name, tierLabel: TIER_LABELS[firm!.tier] ?? 'Workspace', isPersonal: false };
}
